import { useState } from "react";
import { FiLock, FiUnlock } from "react-icons/fi";
import DeleteModal from "../../../../common/commonModal/DeleteModal";
import { lockSheet } from "../../../../../api/businessAndEnterprise/sheetApi";
import ReactNotifications, { showApiErrors } from "../../../../common/reactNotifications/ReactNotifications";
import * as utilConstants from "../../../../../utils/constants/utilsConstants";

const SheetLockFeature = ({ id, isSheetLock, setIsSheetLock }) => {
    const [isConfModal, setIsConfModal] = useState(false);

    const handleLockFeature = () => {
        if (id) {
            lockSheet(id, { is_locked: !isSheetLock }, (res) => {
                if (res?.status === true || res?.status === 200) {
                    ReactNotifications(res?.message || res?.data?.message, utilConstants.sucessState200);
                    setIsConfModal(false);
                    setIsSheetLock(!isSheetLock);
                } else {
                    showApiErrors(res);
                }
            });
        }
    }

    return (
        <div>
            <div
                className="relative group flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1 cursor-pointer transition-all duration-200"
                onClick={() => setIsConfModal(true)}
                onMouseEnter={(e) => {
                    const tooltip = e.currentTarget.querySelector('.lock-tooltip');
                    if (tooltip) tooltip.style.opacity = '1';
                }}
                onMouseLeave={(e) => {
                    const tooltip = e.currentTarget.querySelector('.lock-tooltip');
                    if (tooltip) tooltip.style.opacity = '0';
                }}
            >
                {!isSheetLock ? <FiLock size={28} /> : <FiUnlock size={28} />
                }


                <div
                    className="lock-tooltip z-[10000] absolute top-full left-1/2 mb-2 px-3 py-1.5 bg-gray-900 text-white text-xs rounded-md whitespace-nowrap pointer-events-none transition-opacity duration-200"
                    style={{
                        transform: 'translateX(-50%)',
                        opacity: 0,
                    }}
                >
                    {!isSheetLock ? 'Lock' : 'Unlock'} Access
                    <div
                        className="absolute bottom-full left-1/2 border-4 border-transparent border-b-gray-900"
                        style={{ transform: 'translateX(-50%)', marginBottom: '-8px' }}
                    ></div>
                </div>
            </div>

            <DeleteModal
                show={isConfModal}
                onClose={() => setIsConfModal(false)}
                onConfirm={handleLockFeature}
                confirmText={!isSheetLock ? `Lock` : `Unlock`}
                title={isSheetLock ? `Allow Editing Access?` : `Restrict Editing Access?`}
                message={ isSheetLock ? `Are you sure you want to unlock this sheet? This will allow editing permissions to all shared users.` : 
                    `Are you sure you want to lock this sheet? This will revoke editing permissions from all shared users.`}
            />
        </div>
    );
};

export default SheetLockFeature;